export default {
  data () {
    return {
      //  屏幕宽度
      clientWidth: 0,
      //  屏幕高度
      clientHeight: 0,
      recalcMiddleware: [],
      isPc: false,
      docEl: document.documentElement,
      dpr: window.devicePixelRatio || 1,
      maxWidth: 0,
      maxFontSizeWidth: 0,
      getScreenSizeCount: 0
    }
  },
  computed: {
    isIOS() {
      return navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1;
      // return true;
    },
    isAndroid() {
      return navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1;
      // return false;
    },
    getIosVersion() {
      if (this.isIOS) {
        const ua = navigator.userAgent.toLocaleLowerCase();
        if (this.isIOS) {
          return ((ua.match(/os [\d._]*/gi).toString()).replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')).split('.').map(e => e - 0)
        }
      }
      return 0;
      // return [11, 0, 2]
    },
    isWechat: () => navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
    isWownowApp: () => navigator.userAgent.toLowerCase().indexOf('wownow') !== -1,
    wownowVersions() {
      return this.isWownowApp && (navigator?.userAgent?.toLowerCase()?.split(/[\r\s\n]/)?.filter(e => e.indexOf('wownow') !== -1)[0]?.split('wownow/')[1]?.split('.')?.map(e => e - 0) ?? 0) || 0;
    },
    phoneRechargeMarketing() {
      return window?.ssrConfig?.routerConfig?.appVersion?.appVersion ?? {
        one: 2,
        two: 4
      };
    },
    isLegitimateVersions() {
      return Array.isArray(this.wownowVersions) && this.wownowVersions.length > 1 &&
        this.wownowVersions[0] >= this.phoneRechargeMarketing.one && this.wownowVersions[1] >= this.phoneRechargeMarketing.two;
    }
  },
  mounted () {
    //  监听可视区域宽高变化
    const resetRecalc = () => {
      //  记录宽度
      const screenSize = this.getScreenSize();
      if (!(screenSize.clientWidth > 0)) {
        return resetRecalc();
      }
      this.clientWidth = screenSize.clientWidth;
      this.clientHeight = screenSize.clientHeight;
      this.dpr = window.devicePixelRatio || 1;
      if (this?.recalcMiddleware?.length) {
        this.recalcMiddleware.forEach(e => typeof e === 'function' && e());
      }
      this.getScreenSizeCount += 1;
      if (this.getScreenSizeCount < 3) {
        const __timeout1 = setTimeout(() => {
          clearTimeout(__timeout1);
          resetRecalc();
        }, 1000);
      }
    }
    //  绑定事件
    window.addEventListener('orientationchange' in window ? 'orientationchange' : 'resize', resetRecalc.bind(this), false)
    window.addEventListener('pageshow', e => e.persisted && resetRecalc());
    if (!this.clientWidth) {
      resetRecalc();
    }
  },
  watch: {
    clientWidth(val) {
      this.computedClientWidth(val);
    }
  },
  methods: {
    computedClientWidth(clientWidth) {
      this.fiexible(clientWidth);
      this.setBodyFontSize();
      this.detectSupports();
    },
    //  detect 0.5px supports 检测 0.5px 的支持
    detectSupports() {
      if (this.dpr >= 2) {
        const fakeBody = document.createElement('body');

        const testElement = document.createElement('div');
        testElement.style.border = '.5px solid transparent';

        fakeBody.appendChild(testElement);
        this.docEl.appendChild(fakeBody);
        if (testElement.offsetHeight === 1) {
          this.docEl.classList.add('hairlines');
        }
        this.docEl.removeChild(fakeBody);
      }
    },
    setBodyFontSize() {
      if (!!document.body) {
        document.body.style.fontSize = `${((12 * this.dpr).toFixed(3) - 0).toFixed(2)}px`;
        return;
      }
      document.addEventListener('DOMContentLoaded', this.setBodyFontSize);
    },
    fiexible(__width) {
      if (__width) {
        const computedWidth = !!(!this.maxWidth || this.maxWidth > __width) && __width || (!!this.maxWidth && !!this.maxFontSizeWidth) && this.maxFontSizeWidth || this.maxWidth;
        this.docEl.style.fontSize = `${((computedWidth / 10).toFixed(3) - 0).toFixed(2)}px`;
      }
    },
    getScreenSize() {
      const __div = document.createElement('div');
      __div.style = 'width: 100%;height: 100%;position: fixed;top: 0;left: 0;'
      document.documentElement.appendChild(__div);
      const ret = {
        clientWidth: __div.clientWidth,
        clientHeight: __div.clientHeight
      };
      __div.remove();
      return ret;
    }
  }
}
